import { render } from "./Home.vue?vue&type=template&id=06185e90&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=06185e90&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06185e90"]])

export default __exports__